import { IEquipment } from '@r1-frontend/api-domru/full-buy/v1/equipment/dto/Equipment.dto';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { Guide } from '@r1-frontend/ui-react/components/Guide';
import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import TextWrapper from '@r1-frontend/ui-react/components/typography/TextWrapper';
import { FullWidthListContainer, IndentContainer, ListContainer } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import { Content, Drawer, Footer, HeaderImage } from '~/src/components/Drawer';
import { setIsShowDetails } from '~/src/features/work-in-home-ab/components/Description/components/TestDrive/context/actions';
import { useContextDispatch, useContextSelector } from '~/src/features/work-in-home-ab/components/Description/components/TestDrive/context/hooks';
import { useTestDriveGuide } from '~/src/features/work-in-home-ab/components/Description/components/TestDrive/hooks/useTestDriveGuide';

import { getDetailsByEquipmentCategory } from '../helpers';

export interface IPurchaseOption {
    price: number,
    value: number,
}

interface IProps {
    equipment: IEquipment,
    onOrder: () => void,
    purchaseOption?: IPurchaseOption,
}

const TestDriveDetails = ({ equipment, onOrder, purchaseOption }: IProps): JSX.Element => {
    const dispatch = useContextDispatch();

    const { isShowDetails } = useContextSelector(state => state);

    const { title, category, testDrive } = equipment;

    const { image, description } = getDetailsByEquipmentCategory({ title, categoryName: category?.name });

    const guide = useTestDriveGuide({ testDrive, purchaseOption });

    const onClose = () => {
        dispatch(setIsShowDetails(false));
    };

    return (
        <Drawer isOpen={isShowDetails} onClose={onClose}>
            <Content>
                <IndentContainer $united={[8, 8, 0]}>
                    <HeaderImage image={image}/>
                </IndentContainer>

                <IndentContainer $desktop={[24, 32]} $mobile={[24]}>
                    <FullWidthListContainer $direction={'column'} $wrap={'nowrap'} $size={24}>
                        <TextWrapper $lastIndent={false}>
                            <H3 $withIndent={false}>Условия тест-драйва</H3>
                            <Paragraph4 $color={COLORS.TextSecondary}>{description}</Paragraph4>
                        </TextWrapper>

                        <ListContainer $direction={'column'} $wrap={'nowrap'} $size={0}>
                            <Guide items={guide}/>
                        </ListContainer>
                    </FullWidthListContainer>
                </IndentContainer>
            </Content>

            <Footer>
                <Button size={'large'} bType={'action'} onClick={onOrder}>
                    Взять в&nbsp;тест-драйв
                </Button>

                <Button size={'large'} bType={'secondary'} onClick={onClose}>
                    Закрыть
                </Button>
            </Footer>
        </Drawer>
    );
};

export default TestDriveDetails;
